import {
  Badge,
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Layout,
  List,
  Space,
  Typography,
} from "antd";
import React, { useContext, useState, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import file from "../components/download/authorization-form.pdf";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from '../components/common/Header';
import { useTranslation } from "react-i18next";
import { ROUTES } from "../constants/Route";
import {LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;

const DownloadLink = () => {
  const { theme } = useContext(ThemeContext)
  const { t } = useTranslation();
  return (
    <a className={`${theme}-color`} href={file} download={true} size="small">
      {t("patient:hIPAA_authorization")}
    </a>
  );
};


const Patient = () => {
  const { t, i18n } = useTranslation();
  const { Content, Footer } = Layout;
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate(); // Hook for navigation
  const [form] = Form.useForm();

  const data = [
    <>{t("patient:if_you_are_not_the_patient_you_will_need_to_submit_a")} <u><DownloadLink /></u> {t("patient:form_click_on_the_link_to_download_a_blank_form")}</>,
    t("patient:patient_name_dob_and_address"),
    t("patient:requester_contact_information"),
    t("patient:location_of_care_received"),
    t("patient:recipient_contact_information"),
  ];

  const validateAgreement = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("patient:please_accept_the_agreement")));
  }, [t]);

  const validationRules = useMemo(() => ({
    agreement: [
      { validator: validateAgreement }
    ]
  }), [validateAgreement]);

  const onFinish = (values) => {
    navigate(ROUTES.PATIENT_DETAILS);
  };

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            List: {
              fontSize: 24,
              lineWidth: "0",
            },
            Layout: {
              footerPadding: 12,
            },
          },
        }}
      >
        {" "}
        <Layout className="bg-white">
          <CustomHeader />
          <Content className="p-6 pb-0">
            <Form 
              key={`patient-form-${i18n.language}`}
              form={form} 
              onFinish={onFinish}
            >
              <div className="container mx-auto followingl-list">
                <List
                  size="small"
                  header={
                    <Title level={3}>
                      {t("patient:you_will_need_the_following_information_to_submit_your_request")}
                    </Title>
                  }
                  footer={
                    <i className="text-base">
                      {t("patient:please_note")} <u>{t("patient:may")}</u> {t("patient:be")} <u>{t("patient:fee")}</u> {t("patient:for_processing_your_request")} <u>{t("patient:you")}</u> {t("patient:with_the_next_steps")}
                    </i>
                  }
                  bordered={false}
                  dataSource={data}
                  renderItem={(item) => (
                    <List.Item className="followingl-list-item">
                      <Typography.Text>
                        {" "}
                        <Badge color="black" style={{ marginTop: "-1rem" }} />
                      </Typography.Text>{" "}
                      <span>{item}</span>
                    </List.Item>
                  )}
                />
                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={validationRules.agreement}
                >
                  <Space className="w-full mb-5">
                    {" "}
                    <Checkbox className="font-medium">
                      {t("patient:i_have")} <span className="highlight-color"> {t("patient:all")} </span>
                      {t("patient:required_information_to_continue_to_the_form")}
                    </Checkbox>
                  </Space>
                </Form.Item>
                <Space className="w-full mt-8 justify-between" align="baseline">
                  <Link to={ROUTES.WELCOME}>
                    <Button type="primary">
                      {t("common:back")}
                    </Button>
                  </Link>
                  <Form.Item>
                    <Button
                      type="primary"
                      onClick={current === 0 ? form.submit : navigate(ROUTES.PATIENT_DETAILS)}
                    >
                      {t('common:continue')}
                    </Button>
                  </Form.Item>
                </Space>
                <Footer className="welcome-footer bg-white">
                  <img
                    className="m-auto"
                    alt="Provider1st Logo"
                    src={window.location.origin + LOGO_SVG_URL}
                  />
                </Footer>
              </div>
            </Form>
          </Content>
        </Layout>
      </ConfigProvider>
    </>
  );
};

export default Patient;
